import React from 'react';
import { ProgressBar } from '@Components/UI/ProgressBar';
import { Container, CheckTitleWrapper, Title } from './HitRow.style';
import { forms } from 'seal-ui-components';

const HitRow = ({
    title,
    text,
    color,
    progress,
    max,
    onSelect,
    isHitChecked,
    withBar,
    roundBorder
}) => {
    return (
        <Container>
            <CheckTitleWrapper>
                <forms.CheckboxField
                    id={`CheckboxField_${title}`}
                    checked={isHitChecked}
                    onChange={e => onSelect(e, text)}
                />
                <Title>{title}</Title>
            </CheckTitleWrapper>
            {withBar && (
                <ProgressBar
                    {...{ color, progress, max }}
                    dimmed={!isHitChecked}
                    roundBorder={roundBorder}
                />
            )}
        </Container>
    );
};

HitRow.defaultProps = {
    title: '',
    // eslint-disable-next-line no-empty-function
    onSelect: () => {}
};

export { HitRow };
